import _ from "lodash";
import moment from "moment/moment";

export function makeHistory(anamnesisHistory) {
    return {
        anamnesisHistory,
        getLatestValueOf: (key) => convertToType(anamnesisHistory?.[key]?.[0]?.anamnesisQuestion?.answer),
        getLatestSubDataRows: (key) => getLatestSubDataRows(anamnesisHistory, key),
    };
}

function getLatestSubDataRows(anamnesisHistory, key) {
    return (
        anamnesisHistory?.[key]?.map((row) =>
            Object.values(row.anamnesisSubData).map((cell) => ({
                question: cell.question,
                answer: cell.answer,
            })),
        ) || []
    );
}

export function possibleVersions(anamnesisHistory) {
    return new Set([
        versionNow(),
        ...Object.keys(anamnesisHistory || {}).flatMap((key) =>
            anamnesisHistory[key].map((item) => item.anamnesisQuestion.version),
        ),
    ]);
}

export function getHistoryAt(anamnesisHistory, version) {
    const clone = _.cloneDeep(anamnesisHistory);
    Object.keys(anamnesisHistory || {}).forEach((key) => {
        const filtered = clone[key]
            .filter((item) => !item.anamnesisQuestion.deletedAtVersion)
            .filter((item) => item?.anamnesisQuestion.version <= version || item.anamnesisQuestion.version === null);
        const first = filtered[0];
        clone[key] = first?.anamnesisQuestion.answer === "SUB_DATA" ? filtered : first ? [first] : [];
    });
    return clone;
}

export function yesOnly(anamnesisHistory) {
    const clone = _.cloneDeep(anamnesisHistory);
    Object.keys(anamnesisHistory || {}).forEach((key) => {
        clone[key] = clone[key].filter((item) => {
            const answer = convertToType(item.anamnesisQuestion.answer);
            return item.anamnesisQuestion.answer === "SUB_DATA"
                ? getLatestSubDataRows(anamnesisHistory, key).some((rows) => isContentFull(rows))
                : (answer || answer === 0) && !["NO_PROBLEM", "NONE", "NO"].includes(answer);
        });
    });
    return clone;
}

export function noOnly(anamnesisHistory) {
    const clone = _.cloneDeep(anamnesisHistory);
    Object.keys(anamnesisHistory || {}).forEach((key) => {
        clone[key] = clone[key].filter(
            (item) =>
                convertToType(item.anamnesisQuestion.answer) === false ||
                ["NO_PROBLEM", "NONE", "NO"].includes(item.anamnesisQuestion.answer),
        );
    });
    return clone;
}

export function isAnyPresent(anamnesisHistory, keys) {
    return keys.some((key) => {
        return (
            anamnesisHistory?.[key]?.length > 0 &&
            (anamnesisHistory?.[key]?.[0]?.anamnesisQuestion?.answer !== "SUB_DATA" ||
                getLatestSubDataRows(anamnesisHistory, key).some((rows) => isContentFull(rows)))
        );
    });
}

export function convertToType(typeMeDaddy) {
    if (typeof typeMeDaddy !== "string") {
        return typeMeDaddy;
    } else {
        let trimmed = typeMeDaddy.trim();
        if (trimmed === "true") {
            return true;
        } else if (trimmed === "false") {
            return false;
        } else {
            //NOTE LM: Both isNaN and Number constructor think that falsy values And empty strings
            // AND text containing only 'whitespace' characters - no ambiguity there whatsoever! - are numbers.
            //They are all the number 0 obviously... Fuck you, that's why. Fuck the horse you rode in on too.
            if (isNaN(trimmed) || trimmed === "") {
                return trimmed;
            } else {
                return Number(trimmed);
            }
        }
    }
}

export function convertedEquals(a, b) {
    return convertToType(a) === convertToType(b);
}

export function isUndetermined(value) {
    return value === null || value === undefined;
}

export function isExplicitlyChosen(value) {
    const result = convertToType(value);
    return result === true || result === false;
}

export function weekOfYearNow() {
    return moment().isoWeek().toString().padStart(2, "0");
}

export function versionNow() {
    return `${moment().year()}-${weekOfYearNow()}`;
}

export function isPrimitiveEmpty(primitive) {
    return isUndetermined(primitive) || trim(primitive) === "";
}

function trim(text) {
    return typeof text === "string" ? (text || "").replaceAll(/\s/g, "") : text;
}

export function isContentFull(rows) {
    return rows.some((cell) => {
        return cell.answer !== undefined && cell.answer !== null && trim(cell.answer) !== "";
    });
}
